import { SubStatusConfig } from '../config/sub-status.config';
import { SubStatusCodes } from '../enums/order-sub-status.enums';
import { FilledStatusInfo, StatusInfo } from '../models/order-status.model';

export const getSubOrderStatus = (code: SubStatusCodes): StatusInfo => {
    return SubStatusConfig[code];
};

export const getDateForSubOrderStatusTracking = (status: StatusInfo, statusTracking: any): FilledStatusInfo => {
    return {
        ...status,
        date: statusTracking.fechaActualizacion,
    };
};
